/**
 * Formats a number with thousands separators (spaces) and appends UZB currency suffix.
 * Example: 100000 -> "100 000 SUM"
 */
export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  const num = Number(value);
  if (isNaN(num)) return value;
  
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " SUM";
};

/**
 * Formats a number with thousands separators (spaces) only.
 * Example: 100000 -> "100 000"
 */
export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const num = value.toString().replace(/\D/g, ''); // Strip non-digits
  return num.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

/**
 * Parses a formatted string back to a number.
 * Example: "100 000" -> 100000
 */
export const parseNumber = (value) => {
  if (typeof value !== 'string') return value;
  const stripped = value.replace(/\s/g, '');
  return stripped ? Number(stripped) : '';
};
